import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ModalDismissReasons, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { NgxSpinnerService } from 'ngx-spinner';
import { ContentAuthoringService } from 'src/app/services/content-authoring.service';


// export interface UserData {
//   Ticket_Raised_by: string;
//   Requested_on: string;
//   Message: string;
//   Enquiry_Status: string;
// }
export interface UserData {
  Ticket_Raised_by: string;
  Requested_on: string;
  Message: string;
  Enquiry_Status: string;
}

@Component({
  selector: 'app-manage-tickets',
  templateUrl: './manage-tickets.component.html',
  styleUrls: ['./manage-tickets.component.scss']
})
export class ManageTicketsComponent implements OnInit {

  userId: any = ''; type: any = '';
  searchText = ""; user_status = "2"; is_active = "1"; order_by = "created_dttm"; order = "DESC";
  errorInfo: { isError: boolean, errorMsg: string } = { isError: false, errorMsg: '' }
  data = {}; userData: any; adminData: any;
  status: any = ''
  closeResult: string='';
  tcktCount:number=0;
  resetRqstCount:number=0;
  ticket_id: any;

  constructor(private modalService: NgbModal, private contentAuthoringApi: ContentAuthoringService,
    private route: ActivatedRoute,
    private router: Router, private spinner: NgxSpinnerService) {
    if (localStorage.getItem('adminData') == '' || localStorage.getItem('adminData') == null) {
      this.router.navigateByUrl('/admin-login');
    }
  }

  ngOnInit(): void {
    this.spinner.show();
    this.is_active = '1';
    this.getTickets(this.searchText, this.is_active, this.order_by, this.order, this.status);
    this.adminData = JSON.parse(localStorage.getItem('adminData') || '[]');

  }
  // selectChangeHandler(event: any) {
  //     this.filter_by = event.target.value;
  //     if (this.filter_by == 0) {
  //       this.filter_by = "";
  //       this.getTickets(this.searchText, this.is_active, this.order_by, this.order, this.status, );
  //     } else {
  //       this.getTickets(this.searchText, this.is_active, this.order_by, this.order, this.status);
  //     }
  //   }

  getUserDetails(courseId: any) {
  }
  /*******get active and deactive data of users */
  onSelectChange(event: any) {
    if (event.index == 1) { //Resolved
      this.status = 2;
    } else {
      this.status = ''; //All
    }
    this.getTickets(this.searchText, this.is_active, this.order_by, this.order, this.status);
  }
  /*get user listing data********/
  getTickets(searchText: any, is_active: any, order_by: any, order: any, status: any) {
    this.spinner.show();
    this.contentAuthoringApi.getTicketData(searchText, is_active, order_by, order, status).subscribe(
      (data) => {
        // console.log(data);
        if (data.success) {
          this.spinner.hide();
          this.userData = data.userData;
          // console.log(this.userData);
        } else {
          this.spinner.hide();
          this.errorInfo.isError = true;
          this.errorInfo.errorMsg = 'No data Exist'
        }
      },
      (error) => {
        this.spinner.hide();
        this.errorInfo.errorMsg = error;
      },
    );
  }

  /*****get data by searching by name */
  search(event: any) {
    this.searchText = event.target.value;
    this.getTickets(this.searchText, this.is_active, this.order_by, this.order, this.status);
  }

  sortData(sort: any) {
    if (sort.direction == 'desc') {
      this.order_by = sort.active; this.order = 'DESC';
    } else if (sort.direction == 'asc') {
      this.order_by = sort.active; this.order = 'ASC';
    } else { this.order_by = 'created_dttm'; this.order = 'DESC'; }
    // this.courseList(this.course_name, this.is_active, this.course_status, this.order_by, this.order);
    this.getTickets(this.searchText, this.is_active, this.order_by, this.order, this.status);
  }
  /*****click on logout button function ******/
  logout() {
    //localStorage.clear();
    localStorage.removeItem('adminLoginPass');
    localStorage.removeItem('adminData');
    this.router.navigate(['./admin-login']);
  }

  markResolved(contactID:any){
    this.spinner.show();
    const postJson = {
      "contact_id": contactID,
      "status": 2
    }
    this.contentAuthoringApi.markResolved(postJson).subscribe(
      (data) => {
        // console.log(data);
        if (data.success) {
          this.spinner.hide();
          document.getElementById('successMsg')?.click();
         // alert('Tickect has been resolved successfully')
          this.getTickets(this.searchText, this.is_active, this.order_by, this.order, this.status);
          this.getTicketCount()
        } else {
          this.spinner.hide();
          this.errorInfo.isError = true;
          this.errorInfo.errorMsg = 'Somthing went wrong'
        }
      },
      (error) => {
        this.spinner.hide();
        this.errorInfo.errorMsg = error;
      },
    );
  }
  getTicketCount() {
    const jsonPost={
      email: this.adminData.email
    }
    this.contentAuthoringApi.ticketCountDetail(jsonPost).subscribe(
      (data) => {
        if (data.success) {
          this.tcktCount= data.ticket_count;
          this.resetRqstCount= data.reset_req_count
        } else {
          this.errorInfo.isError = true;
          this.errorInfo.errorMsg = 'No data Exist';
        }
      },
      (error) => {
        this.errorInfo.errorMsg = error;
      },
    );
  }
  open(content: any) {
    this.modalService.open(content, { ariaLabelledBy: 'modal-basic-title', centered: true }).result.then((result) => {
      this.closeResult = `Closed with: ${result}`;
    }, (reason) => {
      this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
    });
  }
  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return `with: ${reason}`;
    }
  }
  openDletMdl(content: any, ticket_id: any, tab_name: any) {
    this.ticket_id=ticket_id
    this.modalService.open(content, { size: 'sm', centered: true }).result.then((result) => {
      this.closeResult = `Closed with: ${result}`;
    }, (reason) => {
      this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
    });
  }
  deleteTicket() {
    this.contentAuthoringApi.deleteTickets(this.ticket_id).subscribe(
      (data) => {
        if (data.status == 200) {
          document.getElementById('closelId')?.click();
          this.getTickets(this.searchText, this.is_active, this.order_by, this.order, this.status);
          this.getTicketCount()
        } else {
        }
      },
      (error) => { },
    );
  }
}


